import ApiService from './api.service.js';

export default {
  getlPlan(clientId) {
    return ApiService.get(`/plans/client/${clientId}?expired=true`);
  },
  sendCancelPlanEmail(partnerId, name, type) {
    return ApiService.post('/tasks/send-cancel-plan/run', {
      id: partnerId,
      name,
      type
    });
  }
};
